<div class="page-content-small page-fill d-flex flex-row">
    <div class="flex-fill d-flex flex-column">
        <div class="d-flex">
            <div class="column ms-2 me-2"><span class="color-legend waiting-on-dealer-ach"></span> - Waiting on Dealer-ACH</div>
            <!-- <div class="column ms-2 me-3"><span class="color-legend waiting-on-ach-order-details"></span> - Waiting on Details Delivered-COD</div> -->
            <div class="column ms-2 me-2"><span class="color-legend ach-approved"></span> - ACH Approved By Dealer, Waiting On Order Submit</div>
            <div class="column ms-2 me-2"><span class="color-legend ach-ready-to-initiate"></span> - ACH Ready To Initiate</div>
            <div class="column ms-2 me-2"><span class="color-legend ach-initiated"></span> - ACH Initiated</div>
            <div class="column ms-2 me-2"><span class="color-legend ach-ready-to-complete"></span> - ACH Ready To Complete</div>
            <div class="column ms-2 me-2"><span class="color-legend ach-complete"></span> - ACH Completed</div>
            <div class="column ms-2 me-2"><span class="color-legend declined-to-acknowledge"></span> - Confirmation Declined</div>
        </div>
        <div class="m-1 grid-fill" *ngIf="aches">
            <dx-data-grid
                #dataGrid
                keyExpr="id"
                [dataSource]="aches"
                [columnAutoWidth]="false"
                [showBorders]="true"
                (onToolbarPreparing)="onToolbarPreparing($event)"
                (onCellDblClick)="rowDoubleClick($event)"
                (onOptionChanged)="onOptionChanged($event)"
                (onContentReady)="onContentReady($event)"
                (onRowPrepared)="rowPrepare($event)"
                (onExporting)="onExporting($event)"
            >
                <dxi-column dataField="id" width="75" [sortIndex]="0" sortOrder="desc"></dxi-column>
                <!-- <dxi-column dataField="noteCount" width="75" cellTemplate="notesTemplate"></dxi-column> -->
                <dxi-column dataField="dealer.companyName" caption="Dealer" width="200" cellTemplate="dealerLinkTemplate"></dxi-column>
                <dxi-column dataField="code" width="200" caption="ACH Code" cellTemplate="achCodeTemplate"></dxi-column>
                <dxi-column dataField="confirmation.code" width="200" caption="Confirmation Code" cellTemplate="confirmationCodeTemplate"></dxi-column>
                <dxi-column dataField="invoiceList" caption="Invoices" cellTemplate="invoiceTemplate" width="80"></dxi-column>
                <dxi-column dataField="confirmation.order.invoiceNumber" caption="Sales Order #" cellTemplate="orderLinkTemplate" width="80"></dxi-column>
                <dxi-column dataField="confirmation.order.type.name" caption="Order Type" width="90"></dxi-column>
                <dxi-column dataField="confirmation.order.total" caption="Order Total" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-column>
                <dxi-column dataField="invoicesTotal" caption="Invoice(s) Total" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-column>
                <dxi-column dataField="amount" caption="ACH Form Amount" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-column>
                <dxi-column dataField="emailed" caption="ACH Link Emailed" width="100"></dxi-column>
                <dxi-column dataField="emailTo" caption="ACH Link Emailed To" width="100"></dxi-column>
                <dxi-column dataField="viewed" caption="ACH Viewed" format="shortDateShortTime" width="130"></dxi-column>
                <dxi-column dataField="approved" caption="ACH Approved" format="shortDateShortTime" width="130"></dxi-column>
                <dxi-column dataField="approvedBy" caption="ACH Approved By" width="100"></dxi-column>
                <dxi-column dataField="initiatedTransfers" caption="ACH Initiated" format="shortDateShortTime" width="130"></dxi-column>
                <dxi-column dataField="manualFormSelected" caption="Submitted Manually" format="shortDateShortTime" width="130"></dxi-column>
                <dxi-column dataField="declined" caption="ACH Declined" format="shortDateShortTime" width="130"></dxi-column>
                <dxi-column dataField="declineReason" width="150"></dxi-column>
                <dxi-column dataField="confirmation.confirmedBy" caption="Confirmation Confirmed By" width="175"></dxi-column>
                <dxi-column dataField="confirmation.approved" format="shortDateShortTime" caption="Confirmation Approved" width="150"></dxi-column>
                <dxi-column dataField="confirmation.declined" format="shortDateShortTime" caption="Confirmation Declined" width="150"></dxi-column>
                <dxi-column dataField="paymentMethodDisplay" caption="Payment Method" width="150"></dxi-column>
                <dxi-column dataField="created" caption="Created" width="100"></dxi-column>
                <dxi-column dataField="completed" width="100"></dxi-column>
                <dxi-column width="20"></dxi-column>

                <div *dxTemplate="let cell of 'notesTemplate'">
                    <a [routerLink]="[]">{{ cell.value }} {{ cell.value === 1 ? 'note' : 'notes' }}</a>
                </div>

                <div *dxTemplate="let cell of 'orderLinkTemplate'">
                    <a [routerLink]="[]" (click)="openOrder(cell.data.confirmation.orderId)">{{ cell.value }}</a>
                </div>

                <div *dxTemplate="let cell of 'invoiceTemplate'">
                    <a *ngFor="let invoiceNumber of cell.data.invoiceList" [routerLink]="[]" (click)="openInvoice(invoiceNumber)">{{ invoiceNumber || '' }} </a>
                </div>

                <div *dxTemplate="let cell of 'dealerLinkTemplate'">
                    <a [routerLink]="['/dealers/overview/' + cell.data.dealerId]">{{ cell.value }}</a>
                </div>

                <div *dxTemplate="let cell of 'achCodeTemplate'">
                    <a [routerLink]="[]" (click)="viewAchForm(cell.data.code)">{{ cell.value }}</a>
                </div>

                <div *dxTemplate="let cell of 'confirmationCodeTemplate'">
                    <a [routerLink]="[]" (click)="viewConfirmation(cell.data.confirmation.code)">{{ cell.value }}</a>
                </div>

                <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
                <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-state-storing [enabled]="true" type="localStorage" storageKey="ach-overview-grid"></dxo-state-storing>
                <dxo-selection [mode]="'multiple'"></dxo-selection>

                <div *dxTemplate="let data of 'toolbarButtons'">
                    <button class="btn btn-success" (click)="open(dataGrid.instance.getSelectedRowsData()[0])" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">
                        Open
                    </button>
                    <button
                        class="btn btn-success ms-4"
                        (click)="emailAchLink(dataGrid.instance.getSelectedRowsData()[0])"
                        [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                    >
                        Email ACH Link
                    </button>
                    <button
                        class="btn btn-success ms-2"
                        (click)="print(dataGrid.instance.getSelectedRowsData()[0])"
                        [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                    >
                        Print
                    </button>
                    <button
                        class="btn btn-danger ms-2"
                        (click)="delete(dataGrid.instance.getSelectedRowsData()[0])"
                        [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                    >
                        Delete
                    </button>
                    <button (click)="toggleShowAll()" class="btn btn-warning ms-4">{{ showAll ? 'Hide Completed' : 'Show All' }}</button>
                    <button
                        class="btn btn-success ms-4"
                        (click)="completeAch(dataGrid.instance.getSelectedRowsData()[0])"
                        [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                    >
                        Mark Complete
                    </button>
                    <!-- <button
                        class="btn btn-success ms-4"
                        (click)="addNote(dataGrid.instance.getSelectedRowsData()[0])"
                        [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                    >
                        Add Note
                    </button> -->
                </div>

                <dxo-summary>
                    <dxi-total-item column="amount" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"> </dxi-total-item>
                </dxo-summary>

                <div *dxTemplate="let data of 'toolbarText'">
                    <span *ngIf="aches" class="me-3">
                        <strong>
                            {{ dataGrid.instance.totalCount() + ' items' }}
                            {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                        </strong>
                    </span>
                </div>
            </dx-data-grid>
        </div>
    </div>
</div>
